import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useMedia } from "react-use";
import { Space } from "antd";
import { TWO_FACTOR_AUTH } from "constants/appConstant";
import { getIn, useFormik } from "formik";
import { AuthInfo } from "stores/slices/auth";
import { setHeaderTitle } from "stores/slices/layout";
import { getWorkspaceInfo, WorkspaceInfo } from "stores/slices/workspace";
import {
  doGetUserSettingEvent,
  doUpdateWorkspaceUser,
  isSaving,
  workspaceUserDetail,
} from "stores/slices/workspaceUser";

import AppButton from "components/button";
import FormInput from "components/forms/components/formInput";

import styles from "../styles.module.scss";

const UserSettingPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const below768 = useMedia("(max-width: 1100px)");
  const authInfo = useSelector(AuthInfo);
  const workspaceInfo = useSelector(WorkspaceInfo);
  const workspaceUserInfo = useSelector(workspaceUserDetail);

  const loading = useSelector(isSaving);

  const twoFactorAuthOption = [
    {
      id: TWO_FACTOR_AUTH.NONE,
      name: t("text.none"),
      disabled: false,
    },
    {
      id: TWO_FACTOR_AUTH.GOOGLE_AUTH,
      name: t("text.googleAuthenticator"),
      disabled: false,
    },
    {
      id: TWO_FACTOR_AUTH.EMAIL,
      name: t("text.email"),
      disabled: false,
    },
  ];

  // const inputItemsOne = [
  //   {
  //     type: "switch",
  //     key: "allowAdminLogin",
  //     label: t("text.allowAdmin"),
  //     span: 24,
  //     colon: false,
  //     style: {
  //       marginBottom: 0,
  //       textAlign: below768 ? "left" : "right",
  //       fontWeight: "500",
  //     },
  //   },
  // ];

  const inputItemsTwo = [
    {
      type: "select",
      key: "twoFactorAuth",
      label: t("text.twoFactor"),
      options: twoFactorAuthOption,
      span: 24,
      colon: false,
      noAllowClear: true,
      style: {
        marginBottom: 0,
        textAlign: below768 ? "left" : "right",
        fontWeight: "500",
      },
      config: {
        width: "30%",
        textAlign: "center",
        disabled:
          workspaceInfo?.workspaceSetting?.forceAllUserTwoFactorAuthenticator,
      },
    },
  ];

  // const inputItemsThree = [
  //   {
  //     type: "switch",
  //     key: "soundOne",
  //     label: t("text.sound_1"),
  //     span: 24,
  //     colon: false,
  //     style: {
  //       marginBottom: 0,
  //       textAlign: below768 ? "left" : "right",
  //       borderBottom: "0.5px solid #F4F5F7",
  //       padding: "16px 24px",
  //       fontWeight: "500",
  //     },
  //   },
  //   {
  //     type: "switch",
  //     key: "soundTwo",
  //     label: t("text.sound_2"),
  //     span: 24,
  //     colon: false,
  //     style: {
  //       marginBottom: 0,
  //       textAlign: below768 ? "left" : "right",
  //       borderBottom: "0.5px solid #F4F5F7",
  //       padding: "16px 24px",
  //       fontWeight: "500",
  //     },
  //   },
  //   {
  //     type: "switch",
  //     key: "soundThree",
  //     label: t("text.sound_3"),
  //     span: 24,
  //     colon: false,
  //     style: {
  //       marginBottom: 0,
  //       textAlign: below768 ? "left" : "right",
  //       padding: "16px 24px",
  //       fontWeight: "500",
  //     },
  //   },
  // ];

  const onSubmitForm = async data => {
    if (authInfo && authInfo.id && authInfo.workspaceId) {
      const request = {
        allowAdminLogin: data.allowAdminLogin,
        twoFactorAuth: data.twoFactorAuth,
        sound1: data.soundOne,
        sound2: data.soundTwo,
        sound3: data.soundThree,
        workspaceId: authInfo.workspaceId,
        userId: authInfo.id,
      };
      await dispatch(doUpdateWorkspaceUser(request));
      await dispatch(
        doGetUserSettingEvent({
          userId: authInfo.id,
          workspaceId: authInfo.workspaceId,
        })
      );
    }
  };

  const handleForm = useFormik({
    initialValues: {
      allowAdminLogin: false,
      twoFactorAuth: "NONE",
      soundOne: false,
      soundTwo: false,
      soundThree: false,
    },
    onSubmit: onSubmitForm,
  });

  const { values, setFieldValue, handleSubmit, setValues } = handleForm;

  useEffect(() => {
    if (authInfo && authInfo.id && authInfo.workspaceId) {
      dispatch(
        doGetUserSettingEvent({
          userId: authInfo.id,
          workspaceId: authInfo.workspaceId,
        })
      );
    }
  }, []);

  useEffect(() => {
    dispatch(setHeaderTitle("setting"));
    if (authInfo && authInfo.workspaceId) {
      loadData();
    }
  }, [authInfo]);

  const loadData = async () => {
    await dispatch(getWorkspaceInfo(authInfo.workspaceId));
  };

  useEffect(() => {
    if (workspaceUserInfo) {
      setValues({
        allowAdminLogin: workspaceUserInfo.allowAdminLogin,
        twoFactorAuth: workspaceUserInfo.twoFactorAuth,
        soundOne: workspaceUserInfo.sound1,
        soundTwo: workspaceUserInfo.sound2,
        soundThree: workspaceUserInfo.sound3,
      });
    }
  }, [workspaceUserInfo?.createdTime]);

  return (
    <div className={styles.settingPage}>
      <div className={styles.settingContent}>
        {/* <Space
          direction="vertical"
          size="small"
          style={{
            display: "flex",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            padding: "16px 24px",
            border: "1px solid #DEE1E5",
            marginBottom: "16px",
          }}
        >
          <FormInput
            items={inputItemsOne.map(item => {
              item.label = t(item.label);
              if (item.key) {
                item.value = getIn(values, item.key);
              }
              return { ...item };
            })}
            form={handleForm}
            onChange={setFieldValue}
            layout={below768 ? "vertical" : "horizontal"}
          />
        </Space> */}
        <Space
          direction="vertical"
          size="small"
          style={{
            display: "flex",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            padding: "16px 24px",
            border: "1px solid #DEE1E5",
            marginBottom: "16px",
          }}
        >
          <FormInput
            items={inputItemsTwo.map(item => {
              item.label = t(item.label);
              if (item.key) {
                item.value = getIn(values, item.key);
              }
              return { ...item };
            })}
            form={handleForm}
            onChange={setFieldValue}
            layout={below768 ? "vertical" : "horizontal"}
          />
        </Space>
        {/* <Collapse
          className={styles.settingCollapse}
          expandIconPosition="end"
          size="large"
          defaultActiveKey={["1"]}
          items={[
            {
              key: "1",
              label: t("label.sounds"),
              children: (
                <FormInput
                  items={inputItemsThree.map(item => {
                    item.label = t(item.label);
                    if (item.key) {
                      item.value = getIn(values, item.key);
                    }
                    return { ...item };
                  })}
                  form={handleForm}
                  onChange={setFieldValue}
                  layout={below768 ? "vertical" : "horizontal"}
                />
              ),
            },
          ]}
        /> */}
        <Space
          size="small"
          style={{ display: "flex", justifyContent: "end", marginTop: 16 }}
        >
          <AppButton
            label={t("label.save")}
            color={"primary"}
            type="submit"
            loading={loading}
            onClick={handleSubmit}
          />
        </Space>
      </div>
    </div>
  );
};

export default UserSettingPage;
